export interface IStorageService {
    saveToStorage(key: string, value: any): void,
    loadFromStorage(key: string, defaultValue: any): any
}

class StorageService implements IStorageService {

    /**
     * removeFromStorage - remove from local/session storage
     * @param key - the item that need to be removed
     * @param isSessionStorage - if session storage or local
     */
    removeFromStorage(key: string, isSessionStorage = true): void {
        isSessionStorage ? sessionStorage.removeItem(key) : localStorage.removeItem(key);
    }

    /**
     * saveToStorage - save to local/session storage
     * @param key - the item that need to be saved
     * @param value - the value of this item
     * @param isSessionStorage - if session storage or local
     */
    saveToStorage(key: string, value: any, isSessionStorage = true): void {
        const str = JSON.stringify(value);

        isSessionStorage ? sessionStorage.setItem(key, str) : localStorage.setItem(key, str);
    }

    /**
     * loadFromStorage - load from local/session storage
     * @param key - the item that need to be loaded
     * @param isSessionStorage - if session storage or local
     */
    loadFromStorage(key: string, isSessionStorage = true): any {
        const str = isSessionStorage ? sessionStorage.getItem(key) : localStorage.getItem(key);

        return str ? JSON.parse(str) : '';
    }

    /**
     * addPageOnStorage - add page permissions
     * @param pageName - page name
     */
    addPageOnStorage(pageName) : void {
        const pages = this.loadFromStorage('pages') ? this.loadFromStorage('pages') : [];


        this.saveToStorage('pages', [...pages, pageName]);
    }

    /**
     * findPageAuthorizedOnStorage find Page Authorized On Storage
     * @param pageName - page name
     */
    findPageAuthorizedOnStorage(pageName) : boolean {
        const pages = this.loadFromStorage('pages');

        if (!pages) {
            return false;
        }

        return !!pages.find((page) => page === pageName);
    }

    /**
     * removePageFromStorage - remove page from storage
     * @param pageName - page name
     */
    removePageFromStorage(pageName): void {
        const pages = this.loadFromStorage('pages');
        const index = pages.findIndex((page) => page === pageName);

        index > -1 && pages.splice(index, 1);
        this.saveToStorage('pages', pages);
    }

}

export const storageService = new StorageService();
